import axios from 'axios';
import ApiErrorsEnum from '../enums';

export default class Api {
  constructor(auth, baseURL) {
    this.auth = auth;
    axios.defaults.baseURL = baseURL;
    axios.interceptors.request.use(
      this.onRequest.bind(this),
      this.onRequestError.bind(this),
    );
    axios.interceptors.response.use(
      this.onResponse.bind(this),
      this.onResponseError.bind(this),
    );
  }

  onRequestError(error) {
    return Promise.reject(error);
  }

  onResponseError(error) {
    const {
      response: { status },
    } = error;
    if (status === ApiErrorsEnum.Unauthorized) {
      this.auth.logout();
    }
    return Promise.reject(error);
  }

  onRequest(config) {
    const token = this.auth.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  }

  onResponse(response) {
    return response;
  }
}
